import { VERSION } from './version';

export const environment = {
  urlBasePrefix: 'https://notd.io',
  apiServerBase: 'location.origin',
  gitHash: VERSION.hash,
  buildDate: VERSION.timestamp,
  production: true,
  googleMapsAPIKey: 'AIzaSyDf4XiD03mWFPwPUL2o2U107ejtFDNjRkY',
  transactBaseUrl: 'https://transact.io',
  gtm_id: 'GTM-KDH9MPC',
  contestLinkURL: 'https://notd.io/n/ContestAnnounce',
  contestLinkLabel: 'Contest'
};
